import { generalSetting } from './general.setting';

export const environment = {
  environmentName: 'piima',
  production: true,
  server: 7100,
  // API_BASE_URL: 'http://localhost:7000',
  API_BASE_URL: 'https://rekruting.piima.uz', 
  maxUploadFileSize: 50000000,
  ...generalSetting,
};
